angular.module('galilai.creator').controller('DownloadController', function ($scope, api, $timeout, $rootScope) {
    $scope.view = {
        state: {
            processingDownload: false,
            downloadUrl: null,
            downloadImages: [],
            downloadProgress: 0,
        },
    }

    $scope.post = null

    $rootScope.$on('post.download', function(event, post) {
        $scope.post = post
        if ($scope.post && $scope.post._id) {
            $scope.renderPost()
        }
    })

    let downloadTimer = null
    $scope.renderPost = function() {
        if (!$rootScope.isPremiumCustomer() && ($scope.post.data.format == 'reels' || $scope.post.data.mediaFormat == 'video')) {
            $rootScope.showUpgrade('Publish Reels')
            return
        }
        let postId = $scope.post._id
        $scope.view.state.processingDownload = true
        $scope.view.state.downloadUrl = null
        $scope.view.state.downloadImages = []
        $scope.view.state.downloadProgress = 0;
        let downloadModal = angular.element('#download-modal')
        downloadModal.modal('show', {
            backdrop: 'static',
            keyboard: false
        })

        let numberItems = $scope.post.data.items.length
        let durationPerItem = 3
        let baseDuration = 5
        if ($scope.post.data.format == 'reels' || $scope.post.data.mediaFormat == 'video') {
            durationPerItem = 15
            baseDuration = 45
        }
        let totalDuration = numberItems * durationPerItem + baseDuration
        downloadTimer = setInterval(() => {
            $timeout(() => {
                $scope.view.state.downloadProgress += 100 / (totalDuration)
                if ($scope.view.state.downloadProgress > 100) {
                    $scope.view.state.downloadProgress = 100
                }
            })
        }, 1000)

        function clearProgress() {
            $timeout(function() {
                $scope.view.state.processingDownload = false
            })
            if (downloadTimer) {
                clearInterval(downloadTimer)
            }
        }

        function clear() {
            clearInterval(intervalMonitoring)
            clearProgress()
            downloadModal.modal('hide')
        }

        let intervalMonitoring = null
        function monitorRender(renderId) {
            function check() {
                api.monitorRenderStatus(renderId).then(function(res) {
                    console.log('Monitor render', res.data)
                    if (res.data.status != 'pending') {
                        clearInterval(intervalMonitoring)
                        clearProgress()
                        if (res.data.url) {
                            $timeout(function() {
                                $scope.view.state.downloadUrl = res.data.url
                                $scope.view.state.downloadImages = res.data.images?.map(i => window.BASE_URL + i) || []
                                setTimeout(() => {
                                    $rootScope.checkReviewFeature('download_or_schedule')
                                }, 1000)
                            })
                        } else {
                            // TODO
                            showError(gettext('error.rendering_post'))
                            clear()
                        }
                    }
                })
                .catch(function(err) {
                    clear()
                })
            }
            // A generated post is already rendered and the server answers `done` on the
            // first ask. Waiting a full interval before the first check would show a
            // progress bar for something that was never going to take time.
            check()
            intervalMonitoring = setInterval(check, 5000)
        }
        // Do not save before rendering
        api.scheduleRenderPost(postId).then(function(res) {
            let renderId = res.data.id
            if (!renderId) {
                showError(gettext('error.rendering_post'))
                clear()
                return
            }
            monitorRender(renderId)
        }).catch(function(err) {
            showError(gettext('error.rendering_post'))
            clear()
        })
    }
})